import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Like an item
export const likeItem = async (itemData) => {
  const response = await api.post('/likes', itemData);
  return response.data;
};

// Unlike an item
export const unlikeItem = async ({ item_type, item_id }) => {
  const response = await api.delete(`/likes/${item_type}/${item_id}`);
  return response.data;
};

// Check if user has liked an item
export const checkLikeStatus = async ({ item_type, item_id }) => {
  const response = await api.get(`/likes/status/${item_type}/${item_id}`);
  return response.data;
};

// Get likes count for an item
export const getLikesCount = async ({ item_type, item_id }) => {
  const response = await api.get(`/likes/count/${item_type}/${item_id}`);
  return response.data;
};

// Get users who liked an item
export const getUsersWhoLiked = async ({ item_type, item_id, page = 1, limit = 10 }) => {
  const response = await api.get(`/likes/users/${item_type}/${item_id}?page=${page}&limit=${limit}`);
  return response.data;
};

// Get items liked by the current user or a specific user
export const getUserLikes = async ({ userId = null, item_type = null, page = 1, limit = 10 }) => {
  let url = userId ? `/likes/user/${userId}` : '/likes/user';
  
  // Add query parameters
  const params = new URLSearchParams();
  if (item_type) params.append('item_type', item_type);
  params.append('page', page);
  params.append('limit', limit);
  
  const response = await api.get(`${url}?${params.toString()}`);
  return response.data;
};

// Sync likes counts (admin only)
export const syncLikesCounts = async () => {
  const response = await api.post('/likes/sync');
  return response.data;
};